import { createSymbolActions } from './symbolActions';
import { createStore } from 'zustand/vanilla';

import { createMockEntitlement } from '../../licensing/entitlements';
import { createEmptyProject } from '../../project/model';
import { createAnnotationActions } from './annotationActions';
import { createBasemapViewActions } from './basemapViewActions';
import { createCompositionActions } from './compositionActions';
import { DEFAULT_SHELL_UI_STATE, type AppState } from './appState';
import { createPresentationActions } from './presentationActions';
import { createProjectActions } from './projectActions';
import { createShellSelectionActions } from './shellSelectionActions';

export type {
  AppState,
  CompositionElementSelection,
  CompositionInspectorSection,
  DataChangeResult,
  DisplayFilterChangeResult,
  InspectorTab,
  JoinRemovalImpact,
  JoinRemovalInspectionResult,
  LabelChangeResult,
  PopupChangeResult,
  ShellUiState,
  StyleChangeResult,
} from './appState';

export type AppStore = ReturnType<typeof createAppStore>;

export function createAppStore() {
  return createStore<AppState>()((set, get) => {
    const actionContext = { get, set };

    return {
      mode: 'empty',
      entitlement: createMockEntitlement(
        import.meta.env.MODE === 'test' && import.meta.env.VITE_TEST_ENTITLEMENT === 'pro'
          ? 'pro'
          : 'free',
      ),
      project: createEmptyProject(),
      symbolImportBusy: false,
      symbolImportMessage: '',
      shell: DEFAULT_SHELL_UI_STATE,
      ...createProjectActions(actionContext),
      ...createShellSelectionActions(actionContext),
      ...createBasemapViewActions(actionContext),
      ...createCompositionActions(actionContext),
      ...createPresentationActions(actionContext),
      ...createAnnotationActions(actionContext),
      ...createSymbolActions(actionContext),
    };
  });
}
